module.exports = __webpack_public_path__ + "/images/logo-af-mercadolibre.1ff4a7e.svg";